import { render, staticRenderFns } from "./registerMeiTuanRedeem.vue?vue&type=template&id=543383cf&scoped=true"
import script from "./registerMeiTuanRedeem.vue?vue&type=script&lang=js"
export * from "./registerMeiTuanRedeem.vue?vue&type=script&lang=js"
import style0 from "./registerMeiTuanRedeem.vue?vue&type=style&index=0&id=543383cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543383cf",
  null
  
)

export default component.exports